import { render } from "./CustomEdge.vue?vue&type=template&id=107bdd86&ts=true"
import script from "./CustomEdge.vue?vue&type=script&lang=ts"
export * from "./CustomEdge.vue?vue&type=script&lang=ts"

import "./CustomEdge.vue?vue&type=style&index=0&id=107bdd86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__